import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Home from "./views/Home.vue";
import Donate from "./views/Donate.vue";
import Contact from "./views/Contact.vue";
import Speakers from "./views/Speakers.vue";

Vue.use(Router);

const router = new Router({
	linkExactActiveClass: "active",
	routes: [
		{
			path: "/",
			name: "home",
			components: {
				header: AppHeader,
				default: Home,
				footer: AppFooter,
			},
			meta: {
				//title: "7-я традиция",
			},
		},
		{
			path: "/tradicia-7",
			name: "donate",
			components: {
				header: AppHeader,
				default: Donate,
				footer: AppFooter,
			},
			meta: {
				title: "7-я традиция",
			},
		},
		{
			path: "/speakers",
			name: "speakers",
			components: {
				header: AppHeader,
				default: Speakers,
				footer: AppFooter,
			},
			meta: {
				title: "Спикерские",
			},
		},
		{
			path: "/contact",
			name: "contact",
			components: {
				header: AppHeader,
				default: Contact,
				footer: AppFooter,
			},
		},
	],
	scrollBehavior: (to) => {
		if (to.hash) {
			return { selector: to.hash };
		} else {
			return { x: 0, y: 0 };
		}
	},
});

router.beforeEach((to, from, next) => {
	document.title = (to.meta && to.meta.title) || "АА Словакия";
	if (document.title.indexOf("АА Словакия") == -1) {
		document.title += " · АА Словакия";
	}
	next();
});

export default router;
